import React, { useState } from "react";
import { useColors } from "../contexts/ColorContext";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { getClasses } = useColors();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header
      className={`${getClasses("secondary")} text-white py-4 px-6 shadow-md`}
    >
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <h1 className="text-2xl font-bold">Jambops Solutions</h1>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          <a
            href="#inicio"
            className="hover:text-blue-300 transition duration-300"
          >
            Inicio
          </a>
          <a
            href="#servicios"
            className="hover:text-blue-300 transition duration-300"
          >
            Servicios
          </a>
          <a
            href="#nosotros"
            className="hover:text-blue-300 transition duration-300"
          >
            Nosotros
          </a>
          <a
            href="#contacto"
            className="hover:text-blue-300 transition duration-300"
          >
            Contacto
          </a>
        </nav>

        {/* Mobile Navigation Button */}
        <div className="flex items-center md:hidden">
          <button
            className="text-white focus:outline-none"
            onClick={toggleMenu}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div
          className={`md:hidden ${getClasses("secondary")} mt-2 py-2 px-4 bg-opacity-90`}
        >
          <nav className="flex flex-col space-y-3">
            <a
              href="#inicio"
              className="hover:text-blue-300 transition duration-300"
            >
              Inicio
            </a>
            <a
              href="#servicios"
              className="hover:text-blue-300 transition duration-300"
            >
              Servicios
            </a>
            <a
              href="#nosotros"
              className="hover:text-blue-300 transition duration-300"
            >
              Nosotros
            </a>
            <a
              href="#contacto"
              className="hover:text-blue-300 transition duration-300"
            >
              Contacto
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;
